var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"a-style",on:{"click":function($event){return _vm.linkDownload('https://tools.yufuid.com/')}}},[_vm._v("玉符tools")])])}
var staticRenderFns = []

export { render, staticRenderFns }